import React from 'react';

const ModalTableTextNumericInput = (props) => {

  return (
    <div className="modal-table-row-container">
      <input
        type="text"
        className="modal-table-input"
        value={props.value ? props.value : props.value === 0 ? props.value : ''}
        onChange={(e) => props.handleChange(props.stateIdx, props.stateKey, e.target.value.replace(/,/gi, "."))}
      />
    </div>
  )
}

export default ModalTableTextNumericInput